import usePreinfoButtons from "../../hooks/QuizPage/usePreinfoButtons"
import { TextDiv } from "../common/Text"
import { TwoColumnGrid } from "../common/Buttons"
import styled from "styled-components"
import { AnimatePresence, motion } from "framer-motion"

interface props {
  major: string
  show: boolean
}

const DetailedMajorSelector = ({ major, show }: props) => {
  return (
    <RelativeDiv>
      <AnimatePresence>
        <Container key={major}>
          {show && (
            <TextDiv fontSize={20} $align="start" fontWeight="bold">
              결정한 세부 전공이 있습니까?
            </TextDiv>
          )}
          <TwoColumnGrid>{usePreinfoButtons(major)}</TwoColumnGrid>
        </Container>
      </AnimatePresence>
    </RelativeDiv>
  )
}

export default DetailedMajorSelector

const RelativeDiv = styled.div`
  position: relative;
`

const Container = styled(motion.div).attrs({
  variants: {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: { easings: "easeIn", duration: 0.4 },
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: { easings: "easeOut", duration: 0.2 },
    },
  },
  initial: "hidden",
  animate: "show",
  exit: "exit",
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
